// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mYE8","footer":"styles_footer__1Wfvg"};